import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import 'core-js/features/url-search-params';
import Datepicker from 'vuejs-datepicker';



Vue.use(Vuelidate);


class postsHelper {
    constructor() {
        this.vueConfiguration = {};
        this.vueConfiguration.delimiters = ['${', '}'];
    }

    createPostsVue(el) {
        window.addEventListener('DOMContentLoaded', () => {
            new Vue({
                el: document.querySelector('#posts-vue'),
                delimiters: this.vueConfiguration.delimiters,
                data() {
                    return {
                        hasError: false,
                        allPosts: [],
                        category: '',
                        selectedYear: '',
                        pageNumber: 1,
                        showLoadMore: true
                    };
                },
                created() {
                    $.get('/wp-json/boe-api/v1/get-posts')
                        .done(response => {
                            if (response === null) {
                                this.hasError = true;
                            } else {
                                this.allPosts = response;
                            }
                        })
                        .fail(error => {
                            console.log('ERROR', error);
                            this.submitting = false;
                            this.hasError = true;
                        });
                },
                methods: {
                    loadmore() {
                        this.$set(this, 'pageNumber', this.pageNumber + 1);
                    }
                    
                },
                computed: {
                    paginatedData() {
                        var cutoff = this.pageNumber * 20;
                        if (this.filteredPosts.length > 0 && this.filteredPosts.length < cutoff) {
                            this.$set(this, 'showLoadMore', false);
                        } else if (this.showLoadMore == false) {
                            this.$set(this, 'showLoadMore', true);
                        }
                        return this.filteredPosts.slice(0, cutoff);
                    },
                    filteredPosts() {
                        return this.allPosts
                        .filter(item => {
                            return (item.category.indexOf(this.category) > -1);
                        })
                        .filter(item => {
                            if (this.selectedYear != '') {
                                return (item.year == this.selectedYear);
                            } else {
                                return true;
                            }
                        });
                        
                    },
                    filteredYears() {
                        let years = [];
                        for (let i = 0; i < this.paginatedData.length; i++) {
                            if (!years.includes(this.paginatedData[i].year)) {
                                years.push(this.paginatedData[i].year);
                            }
                        }
                        return years;
                       
                    },
                    years() {
                        let years = [];
                        for (let i = 0; i < this.allPosts.length; i++) {
                            console.log(this.allPosts[i])
                            if (!years.includes(this.allPosts[i].year)) {
                                years.push(this.allPosts[i].year);
                            }
                        }
                        return years;
                    }
                   
                }
            });
        });
    }

    trackAbsenteeBallotForm(el) {
        window.addEventListener('DOMContentLoaded', () => {
            new Vue({
                el: el,
                delimiters: this.vueConfiguration.delimiters,
                data() {
                    return {
                        isActiveMaintenance: null,
                        submitting: false,
                        submitted: false,
                        hasError: false,
                        successfulLookup: false,
                        formData: {
                            electionId: null,
                            firstName: '',
                            lastName: '',
                            dateOfBirth: '',
                            format: el.dataset.format
                        },
                        elections: [],
                        displayData: {},
                        actionUrl: el.dataset.actionUrl,
                    };
                },
                created() {

                    $.get('/wp-json/boe-api/v1/check-maintenance-lock')
                        .done(response => {
                            this.isActiveMaintenance = response;
                        })
                        .fail(error => {
                            console.log('ERROR', error);
                        });

                    $.get('/wp-json/boe-api/v1/get-elections')
                        .done(response => {
                            console.log('RESPONSE', response);
                            if (response === null) {
                            } else {
                                this.elections = response;
                            }

                            // Check for URL Params
                            let urlParams = new URLSearchParams(window.location.search);
                            if (urlParams.has('electionId')) {
                                // The streetNumber field is required on all forms.  If it is present, set the data and submitForm
                                this.formData.electionId = urlParams.get('electionId');
                                this.formData.firstName = urlParams.get('firstName');
                                this.formData.lastName = urlParams.get('lastName');
                                this.formData.dateOfBirth = urlParams.get('dateOfBirth');
                                this.submitForm();
                            }
                        })
                        .fail(error => {
                            console.log('ERROR', error);
                        });
                        
                },
                methods: {
                    submitForm() {
                        this.submitted = true;
                        this.$v.$touch();
                        if (this.$v.$invalid) {
                            return;
                        }

                        this.submitting = true;
                        if (this.actionUrl) {
                            console.log("Redirecting");
                            // redirect to page where form also exists and show results
                            window.location = this.actionUrl + '?' + Object.keys(this.formData).map(key => key + '=' + this.formData[key]).join('&');
                        } else {
                            $.post('/wp-json/boe-api/v1/track-absentee-ballot', this.formData)
                                .done(response => {
                                    console.log('RESPONSE', response);
                                    this.submitting = false;
                                    if (response === null) {
                                        this.hasError = true;
                                    } else {
                                        this.displayData = response;
                                        // Set custom data
                                        this.displayData.Address = this.displayData.AddressNumber2 + " " + this.displayData.AddressPreDirectional + " " + this.displayData.AddressStreet + " " + this.displayData.AddressPostDirectional + " " + this.displayData.AddressSuffix;

                                        if (!this.displayData.DateReturned && !this.displayData.StatusCode) {
                                            this.displayData.Status = 'We have not received your voted ballot.';
                                        } else {
                                            if(this.displayData.StatusCode == '9' || this.displayData.StatusCode == '12' || this.displayData.StatusCode == '33') {
                                                this.displayData.Status = 'Your ballot was received after the deadline. Please contact the Board at 513-632-7000.';
                                            } else if (this.displayData.StatusCode != '0') {
                                                this.displayData.Status = 'Your ballot has incomplete information. Please contact the Board at 513-632-7000.';
                                            } else {
                                                this.displayData.Status = 'Ballot accepted for counting.';
                                            }
                                        }

                                        this.displayData.DateReturned = this.displayData.DateReturned ? this.displayData.DateReturned : "N/A"
                                        this.displayData.DateMailed = this.displayData.DateMailed ? this.displayData.DateMailed : "N/A"

                                        this.successfulLookup = true;
                                    }
                                })
                                .fail(error => {
                                    console.log('ERROR', error);
                                    this.submitting = false;
                                    this.hasError = true;
                                });
                        }
                    },
                    newSearch() {
                        this.hasError = false;
                        this.successfulLookup = false;
                        this.submitted = false;
                        Object.keys(this.formData).forEach(v => this.formData[v] = null);
                        Object.keys(this.displayData).forEach(v => this.displayData[v] = null);
                    },
                    filterInput: function(evt) {
                        evt = (evt) ? evt : window.event;
                        var charCode = (evt.which) ? evt.which : evt.key;
                        console.log(charCode);
                        if ((charCode > 47 && charCode < 58) || (charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 32 || charCode == 13) {
                            return true;
                        } else {
                            evt.preventDefault();
                        }
                    }
                },
                validations: {
                    formData: {
                        electionId: { required },
                        firstName: { required },
                        lastName: { required },
                        dateOfBirth: { validDate }
                    }
                }
            });

            //scroll to the bottom of results
            let urlParams = new URLSearchParams(window.location.search);
            let electionId = urlParams.has('electionId');

            if (electionId) {
                let target = $('.form-box');
                let top = target.offset().top;
                $('html,body').animate({
                    scrollTop: top - 165
                }, 1250);
                return false;
            }
        });
    }

    voterListSearch(el) {
        window.addEventListener('DOMContentLoaded', () => {
            new Vue({
                el: el,
                delimiters: this.vueConfiguration.delimiters,
                created() {
                    $.get('/wp-json/boe-api/v1/check-maintenance-lock')
                        .done(response => {
                            this.isActiveMaintenance = response;
                        })
                        .fail(error => {
                            console.log('ERROR', error);
                        });
                    this.getPrecincts();
                    this.getDistricts();
                },
                data() {
                    return {
                        isActiveMaintenance: null,
                        submitted: false,
                        submitting: false,
                        precincts: [],
                        districtTypes: [
                            // TODO: get these from the DB
                            { key: 'CN', value: 'Congressional' },
                            { key: 'SE', value: 'Senate' },
                            { key: 'HS', value: 'House' },
                            { key: 'school', value: 'School' },
                            { key: 'JD', value: 'Municipal Court' },
                            { key: 'CI', value: 'City' },
                            { key: 'VI', value: 'Village' },
                            { key: 'TW', value: 'Township' },
                            { key: 'WR', value: 'Ward' },
                        ],
                        allDistricts: [],
                        parties: [
                            // TODO: get these from the DB
                            { key: 'NON', value: 'Non-Partisan' },
                            { key: 'DEM', value: 'Democrat' },
                            { key: 'REP', value: 'Republican' },
                            //{ key: 'GRE', value: 'Green' },
                            { key: 'LIB', value: 'Libertarian' },
                        ],
                        dataOptions: {
                            full: 'full',
                            district: 'district',
                            precinct: 'precinct',
                        },
                        partyOptions: {
                            all: 'all',
                            party: 'party',
                        },
                        sortOrderOptions: [
                            { key: 'no', value: 'Name Order' },
                            { key: 'wn', value: 'Walking List, Name Order' },
                            { key: 'pn', value: 'Precinct, Name Order' },
                            { key: 'pwn', value: 'Precinct, Walking List, Name Order' },
                        ],
                        selectedOptions: {
                            dataExport: null,
                            voterPartyAffiliation: null,
                            sortOrder: null,
                            districtType: null,
                            district: null,
                            precinct: null,
                            parties: [],
                        },
                        generatedFileName: null,
                    };
                },
                methods: {
                    getPrecincts() {
                        $.get('/wp-json/boe-api/v1/get-precincts')
                            .done(response => {
                                this.precincts = response;
                            })
                            .fail(error => {
                                console.log('ERROR', error);
                            });
                    },
                    getDistricts() {
                        $.get('/wp-json/boe-api/v1/get-districts')
                            .done(response => {
                                this.allDistricts = response;
                            })
                            .fail(error => {
                                console.log('ERROR', error);
                            });
                    },
                    startExport(exportMethod) {
                        this.$v.$touch();
                        if (this.$v.$invalid) {
                            return;
                        }
                        this.submitted = true;

                        let payload = {
                            exportMethod: exportMethod,
                            officeCode: this.selectedOptions.district,
                            officeType: this.selectedOptions.districtType != 'school' ? this.selectedOptions.districtType : null,
                            party: this.selectedOptions.parties.join(','),
                            sortBy: this.selectedOptions.sortOrder,
                            precinctId: this.selectedOptions.precinct
                        };

                        if (this.selectedOptions.dataExport == this.dataOptions.full) {
                            payload.officeCode = "";
                            payload.officeType = "";
                            payload.precinctId = "";
                        }
                        if (this.selectedOptions.dataExport == this.dataOptions.precinct) {
                            payload.officeType = "";
                            payload.officeCode = "";
                        }
                        if (this.selectedOptions.dataExport == this.dataOptions.district) {
                            payload.precinctId = "";
                        }

                        this.submitting = true;
                        $.post('/wp-json/boe-api/v1/export-voter-lists', payload)
                            .done(response => {
                                console.log('RESPONSE', response);
                                if (response) {
                                    this.submitted = false;
                                    this.submitting = false;
                                    this.generatedFileName = response;
                                    window.location = '/download.php?file=' + response;
                                }
                            })
                            .fail(error => {
                                this.submitted = false;
                                this.submitting = false;
                                console.log('ERROR', error);
                            });
                    },
                },
                computed: {
                    districts() {
                        let districts = [];
                        if (this.selectedOptions.districtType === 'school') {
                            let schoolFilterKeys = ['LS', 'SC', 'VS'];
                            districts = this.allDistricts.filter(d => schoolFilterKeys.includes(d.Type));
                        } else {
                            districts = this.allDistricts.filter(d => d.Type === this.selectedOptions.districtType);
                        }
                        return districts.sort((a, b) => {
                            if (a.Description < b.Description) return -1;
                            if (a.Description > b.Description) return 1;
                            return 0;
                        });
                    },
                },
                validations: {
                    selectedOptions: {
                        dataExport: { required },
                        voterPartyAffiliation: { required },
                        sortOrder: { required },
                    },
                },
            });
        });
    }

    absenteeListSearch(el) {
        window.addEventListener('DOMContentLoaded', () => {
            new Vue({
                el: el,
                delimiters: this.vueConfiguration.delimiters,
                components: {
                    Datepicker
                },
                created() {
                    $.get('/wp-json/boe-api/v1/check-maintenance-lock')
                        .done(response => {
                            this.isActiveMaintenance = response;
                        })
                        .fail(error => {
                            console.log('ERROR', error);
                        });
                    this.getDistricts();
                    this.getElections();
                },
                data() {
                    return {
                        isActiveMaintenance: null,
                        submitted: false,
                        submitting: false,
                        elections: [],
                        districtTypes: [
                            // TODO: get these from the DB
                            { key: 'CN', value: 'Congressional' },
                            { key: 'SE', value: 'Senate' },
                            { key: 'HS', value: 'House' },
                            { key: 'school', value: 'School' },
                            { key: 'JD', value: 'Municipal Court' },
                            { key: 'CI', value: 'City' },
                            { key: 'VI', value: 'Village' },
                            { key: 'TW', value: 'Township' },
                            { key: 'WR', value: 'Ward' },
                        ],
                        allDistricts: [],
                        parties: [
                            // TODO: get these from the DB
                            { key: 'NON', value: 'Non-Partisan' },
                            { key: 'DEM', value: 'Democrat' },
                            { key: 'REP', value: 'Republican' },
                            //{ key: 'GRE', value: 'Green' },
                            { key: 'LIB', value: 'Libertarian' },
                        ],
                        partyOptions: {
                            all: 'all',
                            party: 'party',
                        },
                        applicationTypes: [
                            // TODO: get these from the DB
                            { key: 'All', value: 'All' },
                            { key: 'M', value: 'Mailed' },
                            { key: 'O', value: 'Voted In-Person' },
                            { key: 'P', value: 'Picked Up' },
                        ],
                        sortOrderOptions: [
                            { key: 'pn', value: 'Precinct, Voter Name' },
                            { key: 'zp', value: 'Zip, Precinct' },
                            { key: 'zn', value: 'Zip, Voter Name' }
                        ],
                        selectedOptions: {
                            election: null,
                            // TODO: NEEDS VALIDATION OR PICKER
                            applicationStartDate: null,
                            // TODO: NEEDS VALIDATION OR PICKER
                            applicationEndDate: null,
                            applicationType: 'All',
                            excludeReturnedBallotVoters: null,
                            districtType: 0,
                            district: null,
                            voterPartyAffiliation: 'all',
                            parties: [],
                            sortOrder: 'pn',
                        },
                        generatedFileName: null,
                    };
                },
                methods: {
                    getDistricts() {
                        $.get('/wp-json/boe-api/v1/get-districts')
                            .done(response => {
                                this.allDistricts = response;
                            })
                            .fail(error => {
                                console.log('ERROR', error);
                            });
                    },
                    getElections() {
                        $.get('/wp-json/boe-api/v1/get-elections', { all: true })
                            .done(response => {
                                this.elections = response;
                                this.selectedOptions.election = this.elections[0].ElectionId;
                            })
                            .fail(error => {
                                console.log('ERROR', error);
                            });
                    },
                    startExport(exportMethod) {
                        // this.$v.$touch();
                        // if (this.$v.$invalid) {
                        //     return;
                        // }
                        this.submitted = true;

                        let payload = {
                            exportMethod: exportMethod,
                            ElectionId: this.selectedOptions.election,
                            Application: this.selectedOptions.applicationType != 'All' ? this.selectedOptions.applicationType : null,
                            Exclude: this.selectedOptions.excludeReturnedBallotVoters,
                            RequestedStartDate: this.selectedOptions.applicationStartDate ? moment(this.selectedOptions.applicationStartDate).format('MM/DD/YYYY') : null,
                            RequestedEndDate: this.selectedOptions.applicationEndDate ? moment(this.selectedOptions.applicationEndDate).format('MM/DD/YYYY') : null,
                            pParty: this.selectedOptions.parties.join(','),
                            OfficeCode: this.selectedOptions.district,
                            SortBy: this.selectedOptions.sortOrder,
                        };

                        this.submitting = true;
                        $.post('/wp-json/boe-api/v1/export-absentee-lists', payload)
                            .done(response => {
                                console.log('RESPONSE', response);
                                if (response) {
                                    this.submitted = false;
                                    this.submitting = false;
                                    this.generatedFileName = response;
                                    window.location = '/download.php?file=' + response;
                                }
                            })
                            .fail(error => {
                                this.submitted = false;
                                this.submitting = false;
                                console.log('ERROR', error);
                            });
                    },

                    customDateFormatter(date) {
                        return moment(date).format('MM/DD/YYYY');
                    }
                },
                computed: {
                    districts() {
                        let districts = [];
                        if (this.selectedOptions.districtType === 'school') {
                            let schoolFilterKeys = ['LS', 'SC', 'VS'];
                            districts = this.allDistricts.filter(d => schoolFilterKeys.includes(d.Type));
                        } else {
                            districts = this.allDistricts.filter(d => d.Type === this.selectedOptions.districtType);
                        }
                        return districts.sort((a, b) => {
                            if (a.Description < b.Description) return -1;
                            if (a.Description > b.Description) return 1;
                            return 0;
                        });
                    },
                },
                // validations: {
                //     selectedOptions: {
                //         applicationStartDate: { validDate },
                //         applicationEndDate: { validDate },
                //     },
                // },
            });
        });
    }

    exportElectionResultsForm() {
        window.addEventListener('DOMContentLoaded', () => {
            new Vue({
                el: '#export-election-results-form',
                delimiters: this.vueConfiguration.delimiters,
                created() {
                    $.get('/wp-json/boe-api/v1/check-maintenance-lock')
                        .done(response => {
                            this.isActiveMaintenance = response;
                        })
                        .fail(error => {
                            console.log('ERROR', error);
                        });
                    this.dropdownOptions.accumulatedResults = this.populateDropdown('Accumulated Totals');
                    this.dropdownOptions.primaryElections = this.populateDropdown('Primary Elections');
                    this.dropdownOptions.generalElections = this.populateDropdown('General Elections');
                    this.dropdownOptions.specialElections = this.populateDropdown('Special Elections');
                    this.dropdownOptions.cincinnatiCityCouncelElections = this.populateDropdown('Cincinnati City Council Elections');
                },
                data() {
                    return {
                        isActiveMaintenance: null,
                        dropdownOptions: {
                            accumulatedResults: [],
                            primaryElections: [],
                            generalElections: [],
                            specialElections: [],
                            cincinnatiCityCouncelElections: [],
                        },
                        selectedOptions: {
                            accumulatedResults: null,
                            primaryElections: null,
                            generalElections: null,
                            specialElections: null,
                            cincinnatiCityCouncelElections: null,
                        },
                    };
                },
                methods: {
                    populateDropdown(category) {
                        let collection = [];
                        $.ajax({
                            async: false,
                            type: 'GET',
                            url: '/wp-json/boe-api/v1/get-election-export-options',
                            data: { category: category },
                            success: response => {
                                console.log('RESPONSE', response);
                                collection = response;
                            },
                            error: error => {
                                console.log('ERROR', error);
                            },
                        });
                        return collection;
                    },
                },
            });
        });
    }

    precinctMaps(el) {
        window.addEventListener('DOMContentLoaded', () => {
            new Vue({
                el: el,
                delimiters: this.vueConfiguration.delimiters,
                created() {
                    $.get('/wp-json/boe-api/v1/check-maintenance-lock')
                        .done(response => {
                            this.isActiveMaintenance = response;
                        })
                        .fail(error => {
                            console.log('ERROR', error);
                        });
                    this.precinctMapItems = this.getPrecinctMapItems();
                },
                data() {
                    return {
                        isActiveMaintenance: null,
                        precinctMapItems: null,
                        selectedDirectories: {
                            selectedDirectory1: '',
                            selectedDirectory2: '',
                            selectedDirectory3: '',
                            selectedDirectory4: '',
                            selectedDirectory5: '',
                        }
                    };
                },
                methods: {
                    getPrecinctMapItems() {
                        let collection = [];
                        $.ajax({
                            async: false,
                            type: 'GET',
                            url: '/wp-json/boe-api/v1/get-precinct-map-items',
                            success: response => {
                                console.log('RESPONSE', response);
                                collection = response;
                            },
                            error: error => {
                                console.log('ERROR', error);
                            },
                        });
                        return collection;
                    },
                    resetDropdowns(depth) {
                        switch (depth) {
                            case 1:
                                this.selectedDirectories.selectedDirectory2 = null;
                            case 2:
                                this.selectedDirectories.selectedDirectory3 = null;
                            case 3:
                                this.selectedDirectories.selectedDirectory4 = null;
                            case 4:
                                this.selectedDirectories.selectedDirectory5 = null;
                        }
                    }
                },
                computed: {
                    directory2Items() {
                        let directories = [];
                        if (this.selectedDirectories.selectedDirectory1 && this.selectedDirectories.selectedDirectory1.nodes.length > 0) {
                            directories = this.selectedDirectories.selectedDirectory1.nodes.filter(node => node.type == 'dir');
                        }
                        return directories;
                    },
                    directory3Items() {
                        let directories = [];
                        if (this.selectedDirectories.selectedDirectory2 && this.selectedDirectories.selectedDirectory2.nodes.length > 0) {
                            directories = this.selectedDirectories.selectedDirectory2.nodes.filter(node => node.type == 'dir');
                        }
                        return directories;
                    },
                    directory4Items() {
                        let directories = [];
                        if (this.selectedDirectories.selectedDirectory3 && this.selectedDirectories.selectedDirectory3.nodes.length > 0) {
                            directories = this.selectedDirectories.selectedDirectory3.nodes.filter(node => node.type == 'dir');
                        }
                        return directories;
                    },
                    directory5Items() {
                        let directories = [];
                        if (this.selectedDirectories.selectedDirectory4 && this.selectedDirectories.selectedDirectory4.nodes.length > 0) {
                            directories = this.selectedDirectories.selectedDirectory4.nodes.filter(node => node.type == 'dir');
                        }
                        return directories;
                    },
                    overviewMaps() {
                        let maps = [];
                        if (this.selectedDirectories.selectedDirectory1 && this.directory2Items.length > 0) maps = maps.concat(this.selectedDirectories.selectedDirectory1.nodes.filter(node => node.type == 'file'));
                        if (this.selectedDirectories.selectedDirectory2 && this.directory3Items.length > 0) maps = maps.concat(this.selectedDirectories.selectedDirectory2.nodes.filter(node => node.type == 'file'));
                        if (this.selectedDirectories.selectedDirectory3 && this.directory4Items.length > 0) maps = maps.concat(this.selectedDirectories.selectedDirectory3.nodes.filter(node => node.type == 'file'));
                        if (this.selectedDirectories.selectedDirectory4 && this.directory5Items.length > 0) maps = maps.concat(this.selectedDirectories.selectedDirectory4.nodes.filter(node => node.type == 'file'));
                        return maps;
                    },
                    precinctMaps() {
                        let maps = [];
                        if (this.selectedDirectories.selectedDirectory5) {
                            maps = this.selectedDirectories.selectedDirectory5.nodes.filter(node => node.type == 'file');
                        } else if (this.selectedDirectories.selectedDirectory4 && this.directory5Items.length == 0) {
                            maps = this.selectedDirectories.selectedDirectory4.nodes.filter(node => node.type == 'file');
                        } else if (this.selectedDirectories.selectedDirectory3 && this.directory4Items.length == 0) {
                            maps = this.selectedDirectories.selectedDirectory3.nodes.filter(node => node.type == 'file');
                        } else if (this.selectedDirectories.selectedDirectory2 && this.directory3Items.length == 0) {
                            maps = this.selectedDirectories.selectedDirectory2.nodes.filter(node => node.type == 'file');
                        } else if (this.selectedDirectories.selectedDirectory1 && this.directory2Items.length == 0) {
                            maps = this.selectedDirectories.selectedDirectory1.nodes.filter(node => node.type == 'file');
                        }
                        return maps;
                    }
                }
            });
        });
    }
}

window.app.add('posts', new postsHelper());
